// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUp_signUpContainer__3tTXP","input":"SignUp_input__2EsVJ","errorMsg":"SignUp_errorMsg__2LMRh"};